<!--
* @description  客户中心导航
* @fileName  navTop
* @author userName
* @date 2023-12-25 15:31:51
!-->
<template>
  <div id="navTop" class="navTop">
    <div class="navTop-l">
      <a style="cursor: pointer;height: 64px;display: block;" @click="goToManage('/')">
        <el-image :src="config.logoIcon" style="height: 64px;">
          <template slot="error">
            <img src="@/assets/logo.png" height="64px">
          </template>
        </el-image>
      </a>
    </div>
    <div class="navTop-r">
      <!-- <div class="FindAQuote" @click="toHome">Find a Quote</div> -->
      <div class="">
        <el-dropdown @command="setLanguage">
          <button class="language">
            <i class="icon-ym icon-ym-language" style="font-size: 22px;" />
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="language==='zh'" command="zh">简体中文</el-dropdown-item>
            <el-dropdown-item :disabled="language==='zhtw'" command="zhtw">繁體中文</el-dropdown-item>
            <el-dropdown-item :disabled="language==='en'" command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="logind" @mouseover="navTopAtv=true" @mouseleave="navTopAtv=false">
        <el-avatar :src="customerInfo.userIcon" size="small" @click="goToManage">
          {{ customerInfo.userName }}
        </el-avatar>
        <el-collapse-transition>
          <div v-show="navTopAtv" class="topTipBox-login">
            <div class="navBoxSub-login">
              <div class="navBoxSub-first">
                <!-- <div class="navBoxSub-left"></div> -->
                <div class="navBoxSub-right">
                  <div class="name">{{ customerInfo.userName }}</div>
                  <div class="customer">{{ customerInfo.customerName }}</div>
                  <div class="emil">{{ customerInfo.email }}</div>
                </div>
              </div>
              <div class="line" />
              <div class="navBoxSub-two">
                <div @click="goToManage('/shipments')">{{ $t('common.shipments') }}</div>
                <!-- <div @click="goToManage()">Custom Quotes</div> -->
                <div @click="goToManage('/billing')">{{ $t('common.billing') }}</div>
              </div>
              <div class="line" />
              <div class="navBoxSub-tree">
                <div @click="goToManage('/accountDetails')">{{ $t('common.settings') }}</div>
              </div>
              <div class="line" />
              <div class="navBoxSub-four" @click="logout">{{ $t('common.logout') }}</div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetCurrCustomer,
  Logout
} from '@/api/user'
// import { getCookie, delCookie } from '@/utils/cookiejs'
import {
  getToken,
  removeToken,
  getLanguage,
  getUser,
  setUser
} from '@/utils/auth'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'NavTop',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      navTopAtv: false
    }
  },
  computed: {
    // 计算属性
    language() {
      return this.$store.getters.language || 'zh'
    },
    config() {
      const config = this.$store.getters.config || {}
      window.document.title = config.sysName || 'DTMS'
      return config
    },
    isLogin() {
      return !!this.$store.getters.token
    },
    customerInfo() {
      return getUser() || {}
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    this.$i18n.locale = getLanguage() || 'zh'
    // 实例被创建之后执行代码
    var token = getCookie('token')
    if (token) this.getCustomer()
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    setLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.commit('user/SET_LANGUAGE', lang)
      // document.title = getPageTitle(this.$route.meta.title, this.$route.meta.zhTitle)
    },
    // 方法
    toHome() {
      this.$router.push({
        path: '/'
      })
    },
    getCustomer() {
      GetCurrCustomer().then(res => {
        if (res.code === 200) {
          setUser(res.data)
        }
      })
    },
    goToManage(path) {
      if (!path) {
        path = `/manage`
      }
      const nativeHref = this.$router.resolve({
        path: path
        // query,
      })
      window.location.href = nativeHref.href
    },
    logout() {
      Logout().then(res => {
		  if (res.code === 200) {
		    this.$store.commit('user/SET_TOKEN', '')
		    setUser({})
          this.$router.push({
			  path: '/'
          })
		  }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.navTop {
		height: 64px;
		background: #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.navTop-l {
			margin-left: 32px;
		}

		.navTop-r {
			display: flex;
			align-items: center;
			margin-right: 24px;

			.FindAQuote {
				cursor: pointer;
				width: 128px;
				height: 32px;
				background: rgba(237, 119, 56, 0.12);
				border-radius: 8px;
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #ED7738;
				line-height: 32px;
			}

			.language {
				display: flex;
				border: none;
				background-color: transparent;
				cursor: pointer;
				line-height: 30px;
				margin: 0px 10px;
			}

			.topImg {
				margin: 0 16px;
			}

			.userName {
				width: 32px;
				height: 32px;
				background: #ED7738;
				border-radius: 20px;
				border: 1px solid rgba(233, 85, 6, 0);
				font-size: 18px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #FFFFFF;
				line-height: 32px;
			}

			.logind {
				height: 28px;
				
				.loginInfo {
					width: 32px;
					height: 32px;
					background: #25B4FF;
					border-radius: 20px;
					font-size: 18px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #FFFFFF;
					line-height: 32px;
					margin: 0 24px;
					cursor: pointer;

				}

				&:hover {
					.topTipBox-login {
						display: block;
						overflow: visible !important;
					}
				}

				.topTipBox-login {
					display: block;
					position: absolute;
					z-index: 999;
					width: 240px;
					height: 306px;

					.navBoxSub-login {
						top: 8px;
						position: relative;
						left: -182px;
						background: #FFFFFF;
						box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
						border-radius: 8px;
						border: 1px solid rgba(221, 221, 221, 0.56);
						padding: 16px;
						text-align: left;

						.line {
							width: 208px;
							height: 1px;
							background: #EEEEEE;
							text-align: center;
							margin: 8px 0;
						}

						.navBoxSub-first {
							display: flex;

							.navBoxSub-left {
								@extend .loginInfo;
								width: 40px;
								height: 40px;
								margin: 0 8px 0 0;
								font-size: 23px;
								line-height: 40px;
								text-align: center;
							}

							.navBoxSub-right {
								text-align: left;
								font-family: PingFangSC, PingFang SC;

								.name {
									font-size: 16px;
									font-weight: 500;
									color: #333333;
								}

								.customer {
									color: #a6a6a6;
									font-size: 14px;
								}

								.emil {
									font-size: 14px;
									font-weight: 400;
									color: #777777;
								}
							}

						}

						.navBoxSub-two,
						.navBoxSub-tree {
							font-size: 16px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;

							div {
								padding: 8px 0;
								cursor: pointer;
							}
						}

						.navBoxSub-four {
							font-size: 16px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #777777;
							/* padding: 8px; */
							text-align: left;
							cursor: pointer;
						}
					}

				}
			}
		}
	}
</style>
